import ApiFetcher from "../utils/ApiFetcher";
import { put, call } from "redux-saga/effects";
import { makeQueryString } from "../utils/urls";
import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaSearchSuccess,
  sagaCreateSuccess,
  sagaUpdateSuccess
} from "../actions/ActionTypes";
import { showSuccessMsg, showErrorMsg } from "../actions";
const ASSETS = "ASSETS";
const ASSET = "ASSET";
const apiFetcher = new ApiFetcher();
export function* fetchAssets(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `app_assets?${queryString}`);
    yield put({
      type: sagaListSuccess(ASSETS),
      data: res.data
    });
  } catch (e) {}
}

export function* searchAssets(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `app_assets?${queryString}`);
    yield put({
      type: sagaSearchSuccess(ASSETS),
      data: res.data
    });
  } catch (e) {}
}

export function* fetchAsset(action) {
  try {
    const res = yield call(apiFetcher.find, "app_assets", action.id);
    yield put({
      type: sagaOneSuccess(ASSET),
      data: res.data
    });
  } catch (e) {}
}

export function* createAsset(action) {
  try {
    const res = yield call(apiFetcher.create, "app_assets", {
      app_asset: action.data
    });
    yield put({
      type: sagaCreateSuccess(ASSET),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Asset created successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) {}
}

export function* updateAsset(action) {
  //restore old data to form when save fails -> probably in reducer
  try {
    const res = yield call(
      apiFetcher.update,
      "app_assets",
      { app_asset: action.data },
      action.id
    );
    yield put({
      type: sagaUpdateSuccess(ASSET),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Asset details updated successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) {}
}



// WEBPACK FOOTER //
// ./src/sagas/assets.js